import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
// eslint-disable-next-line import/no-unresolved
import { csSyncDataSubject$, SyncDataSubject } from '@creditsights/cs-web';
import { Preference } from '../../models/Preference';
import { updateMyContentPreferences } from '../../services/myContentPreferences/myContentPreferences.service';
import { Channels } from '../../utils/channels';
import { queryKeys } from '../queryKeyFactory';
import { invalidateFeedQueries } from '../../utils/invalidateFeedQueries';
import { ApiError } from '../../services/api-error.model';

export default (): UseMutationResult<void, ApiError, Preference[], { previousPreferences: Preference[] }> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (myContentPreferences: Preference[]) => {
      await updateMyContentPreferences(myContentPreferences);
    },
    {
      onSuccess: async (_, preferences) => {
        queryClient.setQueryData([queryKeys.fetchMyContentPreferences], preferences);
        invalidateFeedQueries(queryClient);
        await Channels.preferencesChannel.postMessage(preferences);
        csSyncDataSubject$.next(SyncDataSubject.USER_PREFERENCE);
      },
    }
  );
};
